import {
  IconAngleRight,
  IconBell,
  IconCheckSquare,
  IconEnvelopeAlt,
} from '@maia/icons';
import { Button, InfoCard, PageHeader } from '@maia/ui';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/add-insurance/$customer/invoice-send',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { customer } = Route.useParams();
  return (
    <div className="layout-sidebar">
      <PageHeader
        title="De offerte is verstuurd"
        description="Er gebeuren allemaal slimme dingen"
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="Offerte email"
              description="De klant ontvangt een email met alle benodigde informatie en de mogelijkheid om de verzekering direct af te sluiten."
            />
          </li>
          <li>
            <InfoCard
              icon={IconBell}
              title="Automatische Herinneringen"
              description="Er worden automatische herinneringen gestuurd bij het niet afronden van de offerte."
            />
          </li>
          <li>
            <InfoCard
              icon={IconCheckSquare}
              title="Taakcreatie bij afwijzing"
              description="Bij afwijzing wordt er een taak aangemaakt voor de broker."
            />
          </li>
        </ul>

        <div className="col-span-full flex justify-end">
          {/* // TODO: Add link to invoice */}
          <Link to="/customers/$guid" params={{ guid: customer }}>
            <Button intent="primary" iconRight={IconAngleRight}>
              Naar offerte
            </Button>
          </Link>
        </div>
      </div>

      <div className="area-page-sidebar invisible"></div>
    </div>
  );
}
